import { Box, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import uuid from "react-uuid";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";

const duration = 400;

const Door = ({ door, index, totalDoors }) => {

    const { t } = useTranslation();

    const [show, setShow] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        // Calculate delay so that all doors animate in 1 second
        const delay = totalDoors > 1 ? index * (1000 / totalDoors) : 0;
        const timer = setTimeout(() => {
            setShow(true);
        }, delay);
        return () => clearTimeout(timer);
    }, [index, totalDoors]);

    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
    }, [copied]);

    return (
        <Tooltip title={!copied ? t("buttons.click_to_copy_phone") : t("buttons.copied")} placement="top">
            <Box
                onClick={() => {
                    navigator.clipboard.writeText(door.doorphone || "");
                    setCopied(true);
                }}
                style={{
                    transition: `all ${duration}ms cubic-bezier(.01,.64,0,1)`,
                    opacity: show ? 1 : 0,
                    transform: show ? 'translateY(0)' : 'translateY(100px)',
                    backgroundColor: ColorScheme.primary,
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 5,
                    paddingBottom: 5,
                    borderRadius: 100,
                    marginRight: 10,
                    cursor: "pointer",
                    display: "inline-block",
                    marginBottom: 20
                }}
            >
                <Typography style={{ fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {door.name}
                </Typography>
                <Typography style={{ fontSize: 10, marginTop: -5, color: ColorScheme.textPrimary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {door.phone ? door.phone : "-"}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export const DoorList = ({ selectedService }) => {
    const { ApiCall } = useContext(ApiContext);

    const { t } = useTranslation();

    const [doors, setDoors] = useState([]);

    useEffect(() => {
        ApiCall("GET", `client/resident_space/doors/${selectedService.id}`, null)
            .then(doors => {
                setDoors(doors);
            });
    }, [selectedService]);

    return (
        <>
            <div
                className="list-fields-container"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "visible",
                    alignItems: "flex-start"
                }}
            >
                <Typography style={{ fontSize: 24, color: ColorScheme.textPrimary, marginBottom: 15 }}>
                    {t("key_management.linked_doors")}
                </Typography>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    overflow: "visible",
                        alignItems: "flex-start",
                        flexWrap: "wrap"
                }}>
                {doors.map((door, index) => (
                    <Door key={uuid()} door={door} index={index} totalDoors={doors.length} />
                ))}
                </div>
            </div>
        </>
    );
};